import {
  useDisableRequalificationModule,
  useGetRequalificationModule,
  useSaveRequalificationModule,
} from './useRequalificationModule'

export { getRequalificationSaveError, REQUALIFICATION_SAVE_FALLBACK_MESSAGE } from './requalificationErrors'
export type { RequalificationActivationCause, RequalificationSaveError } from './requalificationErrors'
export { REQUALIFICATION_MODULE_KEY, REQUALIFICATION_WINDOWS } from './useRequalificationModule'
export type {
  DisableRequalificationModuleRequest,
  RequalificationAnalytics,
  RequalificationDataset,
  RequalificationDisabled,
  RequalificationModuleConfig,
  RequalificationTrigger,
  RequalificationWindow,
  SaveRequalificationModuleRequest,
} from './useRequalificationModule'

export const requalification = {
  get: useGetRequalificationModule,
  save: useSaveRequalificationModule,
  disable: useDisableRequalificationModule,
}
